import React from 'react';
import { motion } from 'framer-motion';
import { useHomepageConfig } from '@/hooks/useHomepageConfig';
import { Editable } from '@/components/edit/Editable';

const DEFAULT_HEADING = 'Why choose us';
const DEFAULT_TAGLINE = 'The New Orleans Leader in Brasilian Entertainment Since 1989';
const DEFAULT_REASONS = [
  "Escola de Samba Casa Samba's Rio de Janeiro Samba Show Experience. A high energy non-stop show presenting the traditional rhythms, songs, dances and costumes of Brasil. Casa Samba re-creates the sights and sounds of Brasil \u2014 this show captures the feel of being in Rio de Janeiro. We also feature the Afro-Brasilian Blocos, Bateria show (percussion band), Passistas (dancers), and Samba Enredos (traditional samba songs from the samba schools in Rio de Janeiro). 15-30-45 minute sets, about 12-24 people needed for this set. For All the above show it would consists of about 30-35 people. This type of performance is recommended for conventions, special events, theatre, festivals and private parties.",
  'To kick off a conventions or meeting sessions opening or closing as well as in between long sessions. Casa Samba Guidance Parades. This parade assists with moving large and small conventioneers from one location to another, indoor or outdoor.',
  'Great way to \u201cWOW\u201d your guests for dinner or luncheon events. The guests are amazed when they hear and see Samba Parade leading out the waiters and servers with their favorite dish or dessert. Generally this is done with an exotic dessert or special food entree.',
  'Casa Samba Parade performance \u2014 this is one of the most in demand for our group. To be able to parade through an event and stop to perform at different locations, or stop spontaneously in the middle of the event. This can happen while one band stops and the stage need to be re-set and there is a 15 to 20 minute downtime before the next band. This will take all the attention away from the set change and keep your event up with high energy.',
  'MEET and GREET, starting by standing at the main entrance of an event as conventioneers enter, after most guests have arrived then before the events starts. We can do a parade around the area to get their attention focused on the start of the event. We can also return and close the same event with different costumes.',
];

export const HomeWhyChooseUs = () => {
  const cfg = useHomepageConfig();
  const wc = cfg?.whyChooseUs || {};
  const heading = wc.heading || DEFAULT_HEADING;
  const tagline = wc.tagline || DEFAULT_TAGLINE;
  const reasons = (Array.isArray(wc.reasons) && wc.reasons.length) ? wc.reasons : DEFAULT_REASONS;

  return (
  <section
    className="py-16 md:py-20 px-6 relative bg-black/35 backdrop-blur-md border-y border-white/10"
    data-testid="why-choose-us-section"
  >
    <div className="max-w-5xl mx-auto">
      <Editable
        as="h2"
        path="whyChooseUs.heading"
        fallback={heading}
        className="text-3xl md:text-4xl font-black text-center mb-10"
        style={{ color: '#F4E400' }}
      />

      <div className="space-y-6" style={{ color: '#F4E400' }}>
        {reasons.map((body, idx) => (
          <motion.p
            key={idx}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.05 }}
            className="text-sm md:text-base leading-relaxed"
          >
            <span className="font-bold">{idx + 1}.)</span>{' '}
            <Editable path={`whyChooseUs.reasons.${idx}`} fallback={body} multiline as="span" />
          </motion.p>
        ))}
      </div>

      <div className="mt-12 text-center">
        <Editable
          as="p"
          path="whyChooseUs.tagline"
          fallback={tagline}
          className="uppercase tracking-widest text-white font-semibold text-sm md:text-base"
        />
      </div>
    </div>
  </section>
  );
};

export default HomeWhyChooseUs;

